import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-4 bg-brand-dark px-4 text-center text-white">
      <div className="font-medium text-6xl text-neutral-500 tracking-tight">404</div>
      <h1 className="font-medium text-2xl tracking-tight">Esta página no existe.</h1>
      <p className="max-w-md text-neutral-400 text-sm">No encontramos lo que buscabas.</p>
      <Link
        to="/"
        className="mt-4 rounded-full border border-white/[0.1] px-5 py-2 font-medium text-sm transition-colors hover:bg-white/[0.05]"
      >
        Volver al inicio
      </Link>
    </main>
  );
}
